import FAQs from "components/FAQ";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
export default function CitiesFAQs({ data }: { data: any[] }) {
  return <FAQs data={data} initialShowPanel={true} />;
}
